












































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';

import VuetifySelectItems from '@/types/app/vuetifySelectItems';

import { CustomerSelectValue } from '@/utils/getCustomers';

import Endpoint from '@/utils/endpoint';
import CustomerService from '@/services/customerService';
import Customer from '@/types/customer/Customer';
import AccountInterface from '@/types/app/accounts';
import UserInterface from '@/types/app/IUser';
import { Watch } from 'vue-property-decorator';
import ErrorService from '@/services/erroService';

const namespace = 'account';

@Component({
  data: () => ({
    required: (v: any) => !!v || 'This field is required',
  }),
})
export default class ModalDetail extends Vue {
  @Getter('getModalCloneAccountState', { namespace })
  modalCloneAccountState!: boolean;

  @Action('setModalCloneAccountState', { namespace })
  setModalCloneAccountState!: any;


  @Getter('getLoading', { namespace }) loading!: boolean;
  @Getter('getActiveCustomers', { namespace:'customer' }) customers!: Customer[];
  @Getter('getAccountsState', {namespace}) accounts!: AccountInterface[];
  @Getter('getUsers', {namespace: 'auth'}) users!: UserInterface[];
  @Action('setUsers', { namespace: 'auth' })
  setUsers!: (users: UserInterface[]) => void;;
  @Action('setLoading', { namespace }) setLoading!: any;

  private endpoint = new Endpoint();

  customersWithAcount: VuetifySelectItems[] = [];
  customerService= new CustomerService(this.$http);
  customersAccount: VuetifySelectItems[] = [];

  account = {
    userIdFrom: '',
    userIdTo: '',
  };

  accountLoading = false;

  @Watch('modalCloneAccountState')
  async loadingUsers() {
    try {
        this.accountLoading = true;
       // this.setUsers(await this.customerService.getAllUsers());
        await this.getCustomers();
    } catch (error) {
      ErrorService.onError(error);
    }
    finally{
        this.accountLoading = false;
    }
    
  }

  private get form(): HTMLFormElement {
    return this.$refs.form as HTMLFormElement;
  }

  async makeACloneAccount() {
    if (this.form.validate()) {
      this.accountLoading = true;

      try {
        const url = this.endpoint.accountsClone;

        this.$http
          .put(`${url}/${this.account.userIdFrom}/to/${this.account.userIdTo}`)
          .then((res: any) => {
            this.clearFields();
            this.closeModal();
          })
          .catch((err) => {
            ErrorService.onError(err);
          });

        this.accountLoading = false;
      } catch (error) {
        ErrorService.onError(error);
      }
    }
  }

  closeModal(): void {
    this.clearFields();
    this.setModalCloneAccountState(false);
  }

  clearFields() {
    this.account.userIdFrom = this.account.userIdTo = '';
    this.form.reset();
  }

  
  async getCustomers(): Promise<void> {

    const customerOrdened = [...this.customers];
    customerOrdened.sort((a,b) => a.fullName.localeCompare(b.fullName));
    
    const itemsForVuetifySelect = await Promise.all(      
      customerOrdened.map(async (item) => {        
        const [
      hasAccount,
      isLCM
    ] = await  Promise.all([this.accounts.find(a => a.userId == item.id) !== null,
       this.users.find(a => a.id == item.id && (a.roles.includes('lcm') || a.roles.includes('admin')))]);
        return {
          text: `${item.fullName} - ${item.email}`,
          value: item.id,
          data: {...item, isLCM: isLCM, hasAccount:hasAccount} ,
        };
      })
    );

    this.customersWithAcount = itemsForVuetifySelect.filter((x) => x.data.hasAccount);
    this.customersAccount = itemsForVuetifySelect.filter((x) => x.data.isLCM);

  }
}
